import {TitleItem} from "../MenuDocumentModel";
import {ReactElement} from "react";
import {FormGroup} from "components/UIComponents/FormGroup";
import {FormattedMessage, useIntl} from "react-intl";
import {FormInput} from "components/UIComponents/FormInput";
import {SubTitle} from "components/UIComponents/SubTitle";
import {menuEditorActions} from "../editorSlice";
import {useAppDispatch} from "lib/redux/hooks";
import {assoc} from "ramda";
import {EditorItem} from "../editorUtils";
import {EditorGroup} from "./EditorGroup";
import { SecondaryButton } from "components/UIComponents/SecondaryButton";

export interface TitleEditorProps {
    title: EditorItem<TitleItem>
}

export function TitleEditor(props: TitleEditorProps): ReactElement {
    const dispatch = useAppDispatch();
    const intl = useIntl();
    const setTitle = (title: string) => dispatch(menuEditorActions.editItem({
        key: props.title.itemKey,
        newItem: assoc('title', title.substring(0, 39), props.title.menuItem)
    }));
    const predefinedTitles = [
        'open',
        'bottled',
    ];

    return (
        <EditorGroup>
            <SubTitle><FormattedMessage id="editor.title"/></SubTitle>
            <FormGroup groupTitle={<></>}>
                <FormInput
                    value={props.title.menuItem.title}
                    onChange={e => setTitle(e.target.value)}
                />
            </FormGroup>

            <FormGroup groupTitle={<FormattedMessage id="editor.title.predefined"/>}>
                <div className="flex flex-col gap-2">
                    {predefinedTitles.map(title =>
                        <SecondaryButton onClick={() => setTitle(intl.formatMessage({id: `editor.title.predefined.${title}`}))}>
                            <FormattedMessage id={`editor.title.predefined.${title}`} />
                        </SecondaryButton>
                    )}
                </div>
            </FormGroup>
        </EditorGroup>
    );
}